import {
    getDistinctDemandFlowArea,
    getDistinctService,
    getDistinctDemandPool,
    getExportPoolFlowAreaSuggestion,
    getPoolDemandSuggestion,
    getFlowAreaDemandSuggestion,
    getMonthlyDistribution,
    getUtilizationPerc,
    getDistinctMonths,
    getReasonResults,
    getLostDemandInfo,
    getFlowAreaLevelValues,
    getRouteDetail,
    getDistinctweekPeriod,
    getBottleneckLevelData,
    getMovesCountData
} from "@/config/sepApiEndPoints";

const getDistinctDemandFlowAreaDetails = async (idToken) => {
    return {
        method: "get",
        url: `${getDistinctDemandFlowArea}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getDistinctServiceDetails = async (idToken) => {
    return {
        method: "get",
        url: `${getDistinctService}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getDistinctDemandPoolDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getDistinctDemandPool}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getExportPoolFlowAreaSuggestionDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getExportPoolFlowAreaSuggestion}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getPoolDemandSuggestionDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getPoolDemandSuggestion}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getFlowAreaDemandSuggestionDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getFlowAreaDemandSuggestion}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getMonthlyDistributionDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getMonthlyDistribution}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getUtilizationPercDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getUtilizationPerc}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getDistinctMonthsDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getDistinctMonths}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getReasonResultsDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getReasonResults}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getLostDemandInfoDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getLostDemandInfo}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getFlowAreaLevelValuesDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getFlowAreaLevelValues}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getRouteDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getRouteDetail}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getDistinctweekPeriodDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getDistinctweekPeriod}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getBottleneckLevelDataDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getBottleneckLevelData}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};

const getMovesCountDataDetails = async (requestData, idToken) => {
    return {
        method: "post",
        url: `${getMovesCountData}`,
        headers: {
            Authorization: `Bearer ${idToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        data: requestData,
        validateStatus(status) {
            return status >= 200 && status < 300 || status === 500 || status === 400
        }
    };
};




export default {
    getDistinctDemandFlowAreaDetails,
    getDistinctServiceDetails,
    getDistinctDemandPoolDetails,
    getExportPoolFlowAreaSuggestionDetails,
    getPoolDemandSuggestionDetails,
    getFlowAreaDemandSuggestionDetails,
    getMonthlyDistributionDetails,
    getUtilizationPercDetails,
    getDistinctMonthsDetails,
    getReasonResultsDetails,
    getLostDemandInfoDetails,
    getFlowAreaLevelValuesDetails,
    getRouteDetails,
    getDistinctweekPeriodDetails,
    getBottleneckLevelDataDetails,
    getMovesCountDataDetails
};
